import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import {
    MomentDateAdapter,
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
} from "@angular/material/core";
import { FORMATO_FECHA } from "app/app.config";

import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment } from "moment";
const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/

@Component({
    selector: "app-dialog-actualizar-vigencia",
    templateUrl: "./dialog-actualizar-vigencia.component.html",
    styleUrls: ["./dialog-actualizar-vigencia.component.scss"],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        /*      {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
*/
        { provide: MAT_DATE_FORMATS, useValue: FORMATO_FECHA },
    ],
    encapsulation: ViewEncapsulation.None,
})
export class DialogActualizarVigenciaComponent implements OnInit {
    formVigenciaCotizacion: FormGroup;
    minFecha: Date;
    constructor(
        private _fb: FormBuilder,
        public dialogRef: MatDialogRef<DialogActualizarVigenciaComponent>
    ) {
        this.minFecha = new Date();
        this.minFecha.setDate(this.minFecha.getDate() + 1);
    }

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.formVigenciaCotizacion = this._fb.group({
            fecha: [
                moment([
                    this.minFecha.getFullYear(),
                    this.minFecha.getMonth(),
                    this.minFecha.getDate(),
                ]),
                { validator: [Validators.required] },
            ],
        });
    }

    cerrar(): void {
        this.dialogRef.close();
    }

    get fecha() {
        return this.formVigenciaCotizacion.get("fecha");
    }
}
